import React from 'react';
import {LinkOnComponent} from 'app/components/links/link';
import {StreamPlaceholder} from 'app/styles/stream';
import {LoadingIndicator, LOADING_MESSAGE, Image, Placeholder, List, Line, Typography} from '@fupa/fupa-uikit';
import {
  ProfileStatisticsRowContent,
  ProfileStatisticsRowInfo,
  ProfileStatisticsRowName,
  ProfileStatisticsRowPhoto,
  ProfileStatisticsRowStat,
  ProfileTypography,
  StatisticsCaption,
  StatisticsCaptionLong,
  StatisticsContainer,
} from 'app/components/profile/ProfileStyles';
import {AdSlot} from 'app/components/ads/AdSlot';
import {getPlayerShortName} from 'app/helpers/helpers';
import {useDataFetchFinished} from 'app/hooks/dataHooks';

const CompetitionScorers = ({scorers, isFetching, isCup, error}) => {
  const competitionStats = isCup ? {goals: 'Tore'} : {goals: 'Tore', assists: 'Assists', matches: 'Sp.'};
  const loadingDataFinished = useDataFetchFinished(isFetching);

  const ScorerRows =
    error && scorers.length === 0 ? (
      <Placeholder>Beim Laden der Daten ist ein Fehler aufgetreten.</Placeholder>
    ) : !isFetching && scorers.length === 0 ? (
      <Placeholder>Es liegen noch keine Daten vor.</Placeholder>
    ) : (
      scorers.map((scorer, index) => {
        const profile = scorer.player;
        const isDeactivated = scorer.player.isDeactivated;
        const stats = Object.keys(competitionStats).map(stat => (
          <ProfileStatisticsRowStat isDeactivated={isDeactivated} align='center' key={`${stat}-stat`}>
            {scorer.statistics[stat]}
          </ProfileStatisticsRowStat>
        ));

        const listContent = (
          <List>
            <ProfileStatisticsRowStat isDeactivated={isDeactivated} align='start'>
              {index + 1}.
            </ProfileStatisticsRowStat>
            <ProfileStatisticsRowInfo>
              <ProfileStatisticsRowPhoto>
                <Image entity='player' circle={true} src={profile.image} ratio='1:1' width={32} height={32} />
              </ProfileStatisticsRowPhoto>
              <ProfileStatisticsRowName>
                <ProfileTypography isDeactivated={isDeactivated} variant='body1'>
                  {getPlayerShortName(profile)}
                </ProfileTypography>
                <ProfileTypography isDeactivated={isDeactivated} variant='caption1'>
                  {scorer.team.name.middle}
                </ProfileTypography>
              </ProfileStatisticsRowName>
            </ProfileStatisticsRowInfo>
            {stats}
          </List>
        );

        const content = isDeactivated ? (
          listContent
        ) : (
          <LinkOnComponent enablehover={true.toString()} to={`/player/${profile.slug}`}>
            {listContent}
          </LinkOnComponent>
        );

        return (
          <ProfileStatisticsRowContent key={profile.slug}>
            {content}
            <Line />
          </ProfileStatisticsRowContent>
        );
      })
    );

  let adUnit = null;
  if (loadingDataFinished) {
    if (scorers.length > 0) {
      ScorerRows.length > 4 ? ScorerRows.splice(5, 0, <AdSlot key='Content_1' adUnit='Content_1' />) : null;
    }
    // Place ad units if content length is not long enough
    // use same key name to get console errors if container is created twice because this would cause too many ad bidder request
    adUnit = !ScorerRows.length || ScorerRows.length <= 4 ? <AdSlot key='Content_1' adUnit='Content_1' /> : null;
  }
  const loadingIndicator = isFetching ? (
    <LoadingIndicator message={LOADING_MESSAGE.loadingPlayers} />
  ) : error && scorers.length ? (
    <StreamPlaceholder>Beim Laden der Daten ist ein Fehler aufgetreten.</StreamPlaceholder>
  ) : null;

  const captionStats = Object.keys(competitionStats).map(stat => (
    <StatisticsCaption variant='caption1' key={stat}>
      {competitionStats[stat]}
    </StatisticsCaption>
  ));

  return (
    <StatisticsContainer>
      <List>
        <StatisticsCaption variant='caption1'>Pl.</StatisticsCaption>
        <StatisticsCaptionLong variant='caption1'>Spieler</StatisticsCaptionLong>
        {captionStats}
      </List>
      {ScorerRows}
      {adUnit}
      {loadingIndicator}
    </StatisticsContainer>
  );
};

export default CompetitionScorers;
